/* Circular adherence ring — animated SVG showing today's dose-taken % */
import React from "react";

export default function AdherenceRing({ percent = 0, label = "TODAY", size = 160, stroke = 12 }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = c;
  const offset = c - (Math.min(100, percent) / 100) * c;
  return (
    <div className="relative inline-block" data-testid="nl-adherence-ring">
      <svg width={size} height={size}>
        <circle cx={size / 2} cy={size / 2} r={r}
                stroke="var(--nl-line)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r}
          stroke="var(--nl-accent)" strokeWidth={stroke} fill="none"
          strokeLinecap="round"
          strokeDasharray={dash}
          strokeDashoffset={offset}
          className="nl-ring-progress"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ filter: "drop-shadow(0 0 8px rgba(72,202,228,0.55))" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <div className="font-display font-black" style={{ color: "var(--nl-accent)", fontSize: size / 3.2 }}>
          {percent}%
        </div>
        <div className="font-label text-[10px] tracking-widest" style={{ color: "var(--nl-muted)" }}>{label}</div>
      </div>
    </div>
  );
}
